import { getFormValues } from 'redux-form';
import toJS from 'shared/components/toJS';
import withAsyncId from 'shared/components/withAsyncId';
import { bindActionCreators } from 'redux';
import { checkAppStatus, setCompletedAppStatusFields } from 'redux/domain/AppStatus';
import { connect } from 'react-redux';
import { openExitConfirmModal, setApplicationFormData } from 'redux/domain/App';
import withRouter from '../../shared/utils/WithRouter';
import { submitCA } from 'redux/domain/TermsAndConditions';
import {
	setUserConsented,
	setAdditionalProviderReviewCheckboxDisplayed,
} from 'redux/domain/Welcome/creators';
import AppStatus from './AppStatus';

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			checkAppStatus,
			openExitConfirmModal,
			setApplicationFormData,
			submitCA,
			setCompletedAppStatusFields,
			setUserConsented,
			setAdditionalProviderReviewCheckboxDisplayed,
		},
		dispatch,
	);

const mapStateToProps = state => ({
	appStatus: state.appStatus.get('appStatuses'),
	customerId: state.termsAndConditions.get('customerId'),
	settings: state.cache.get('settings'),
	returnedFromThirdPartySite: state.welcome.get('returnedFromThirdPartySite'),
	nextProviderId: state.appStatus.get('nextProviderId'),
	nextProviderName: state.appStatus.get('nextProviderName'),
	nextProviderAutoSubmit: state.appStatus.get('nextProviderAutoSubmit'),
	currentProviderId: state.welcome.get('providerId'),
	formValues: getFormValues('ApplicationEntry')(state),
	locallyStoredEncodedFormValues: state.app.get('applicationFormData'),
	previousApplicationValues: state.termsAndConditions.get('previousApplicationValues'),
	completedAppStatusTitle: state.appStatus.get('completedAppStatusTitle'),
	completedAppStatusText: state.appStatus.get('completedAppStatusText'),
	userConsented: state.welcome.get('userConsented'),
	defaultProvider: state.welcome.get('defaultProvider'),
	additionalProviderReviewCheckboxDisplayed: state.welcome.get(
		'additionalProviderReviewCheckboxDisplayed',
	),
	cfaTraceId: state.welcome.get('cfaTraceId'),
});

const AppStatusContainer = withAsyncId(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(toJS(AppStatus))),
);

export default AppStatusContainer;
export { mapStateToProps, mapDispatchToProps }; // for testing purposes only
